import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Button from '../../components/Button';

// Confetti particle component
const Particle = ({ color }) => (
  <motion.div
    className={`absolute w-1.5 h-1.5 rounded-full ${color}`}
    initial={{
      scale: 0,
      opacity: 1,
      x: 0,
      y: 0
    }}
    animate={{
      scale: [0, 1, 1, 0.5, 0],
      opacity: [1, 1, 1, 0.5, 0],
      x: [0, (Math.random() - 0.5) * 200],
      y: [0, (Math.random() - 0.5) * 200]
    }}
    transition={{
      duration: 0.6,
      ease: 'easeOut',
      times: [0, 0.2, 0.5, 0.8, 1]
    }}
  />
);

const FollowButton = ({ isFollowing, onClick, isLoading }) => {
  // Colors for confetti
  const colors = ['bg-green-400', 'bg-green-500', 'bg-emerald-400', 'bg-emerald-500', 'bg-white'];

  const particles = Array.from({ length: 42 }).map((_, i) => ({
    id: i,
    color: colors[i % colors.length]
  }));

  return (
    <div className="relative">
      <Button
        variant={isFollowing ? 'outline' : 'primary'}
        onClick={onClick}
        isLoading={isLoading}
        className="!min-w-[80px] !min-h-[33px] w-[100%] relative overflow-hidden !px-2 py-[5px]"
      >
        <AnimatePresence mode="wait">
          <motion.div
            key={isFollowing ? 'following' : 'follow'}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{
              duration: 0.15,
              ease: 'easeOut'
            }}
            className="flex items-center justify-center gap-1 text-[12px]"
          >
            {isFollowing ? (
              <>
                Following
                {/*<motion.svg*/}
                {/*    initial={{ scale: 0, opacity: 0 }}*/}
                {/*    animate={{ scale: 1.5, opacity: 1 }}*/}
                {/*    transition={{ delay: 0.1 }}*/}
                {/*    className="w-4 h-4 ml-2"*/}
                {/*    viewBox="0 0 24 24"*/}
                {/*    fill="none"*/}
                {/*    stroke="currentColor"*/}
                {/*    strokeWidth="2"*/}
                {/*>*/}
                {/*    <path d="M20 6L9 17l-5-5" />*/}
                {/*</motion.svg>*/}
              </>
            ) : (
              <>Follow</>
            )}
          </motion.div>
        </AnimatePresence>

        {/* Success ripple */}
        <AnimatePresence>
          {isLoading && (
            <motion.div
              className="absolute inset-0 bg-white"
              initial={{ scale: 0, opacity: 0.3 }}
              animate={{
                scale: 2,
                opacity: 0
              }}
              transition={{
                duration: 0.5,
                ease: 'easeOut'
              }}
              exit={{ opacity: 0 }}
            />
          )}
        </AnimatePresence>
      </Button>

      <AnimatePresence>
        {isFollowing && (
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
            {particles.map((particle) => (
              <Particle key={particle.id} color={particle.color} />
            ))}
          </div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isLoading && (
          <motion.div
            className="absolute -inset-1 bg-green-500/10 rounded-full"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{
              scale: [1, 3.2, 1],
              opacity: [0.5, 0.2, 0]
            }}
            transition={{
              duration: 0.8,
              ease: 'easeInOut',
              times: [0, 0.5, 1]
            }}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default FollowButton;
